import React from 'react';
import _ from 'lodash';
import guid from 'uuid/v1';
import sessionUtils from '@common/helpers/sessionStorage.utils';
import localUtils from '@common/helpers/localStorage.utils';
import gridService from '../services/grid.service';
import * as commonActionType from '@common/store/common/common.actionsType';

const Context = React.createContext();
const { Provider, Consumer } = Context;

class GridFactory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hash: props.hash || guid(),
      ...this.getInitialConfig(props),
      showViewFilter: false,
      isFetched: false,
      data: {
        dataList: [],
        pageCount: 0,
      },
    };

    this.userHasSavedConfig = false;
    this.hasSavedConfiguration = false;
    this.gridReloadToken = undefined;
  }

  async componentDidMount() {
    this.gridReloadToken = PubSub.subscribe(commonActionType.GRID_RELOAD, this.onReloadRequest.bind(this));
    PubSub.subscribe(commonActionType.GRID_SELECTEDITENS_SET, this.setSelectedItens.bind(this));
    PubSub.subscribe(commonActionType.CLEAN_FILTER_GRID, this.clearFilterOnLoad.bind(this));

    let _filterFromService;

    if (!sessionUtils.getItem('isExterno')) {
      _filterFromService = await this.getFilterFromService(this.props.options.webStorage);
    }

    this.applyPreFilter(_filterFromService);

    if (_filterFromService) {
      this.hasSavedConfiguration = true;
      this.setStateAndRefresh({
        ...this.state,
        ...this.getInitialConfig(this.props, _filterFromService),
        showViewFilter: false,
        data: {
          activeItem: undefined,
          dataList: [],
          pageCount: 0,
        },
      });
    } else this.refreshData();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      !_.isEqual(
        {
          ...nextProps.actions,
          ...nextProps.columns,
          ...nextProps.options,
          ...nextProps.order,
          ...nextProps.parameters,
          ...nextProps.toolbar,
          ...nextProps.detail,
          ...nextProps.masterDetail,
          ...nextProps.forceResetPage,
        },
        {
          ...this.props.actions,
          ...this.props.columns,
          ...this.props.options,
          ...this.props.order,
          ...this.props.parameters,
          ...this.props.toolbar,
          ...this.props.detail,
          ...this.props.masterDetail,
          ...this.props.forceResetPage,
        }
      )
    ) {
      this.setStateAndRefresh({
        ...this.state,
        ...this.getInitialConfig({
          ...nextProps,
          columns: nextProps.columns.map((x) => {
            return {
              ...x,
              inputs: x.inputs || [],
            };
          }),
        }),
        showViewFilter: false,
        data: {
          dataList: [],
          pageCount: 0,
        },
      });
    }
  }

  componentWillUnmount() {
    $('html').unbind('click');
    $('.wrapper-grid').unbind('scroll');
    $('.filter.filterContainer.filterBody').remove();
    if (this.gridReloadToken) PubSub.unsubscribe(this.gridReloadToken);
  }

  getInitialConfig(props, _filterFromService) {
    const { filterVersion, forceConfigParameter, webStorage, noStorage } = props.options;

    const _filterWebStorage = noStorage ? undefined : sessionUtils.getItem(webStorage);

    const forceBuilder =
      noStorage ||
      forceConfigParameter ||
      !_filterWebStorage ||
      (!_filterWebStorage.options.filterVersion && filterVersion) ||
      (_filterWebStorage.options.filterVersion && _filterWebStorage.options.filterVersion != filterVersion) ||
      (_filterFromService && _filterFromService.options.filterVersion != filterVersion)
        ? true
        : false;

    const filterToMap = _filterFromService || _filterWebStorage || props;

    var gridConfig = forceBuilder
      ? {
          ...props,
          columns: props.columns.map((x) => {
            return {
              ..._.cloneDeep(x),
              inputs: [],
            };
          }),
        }
      : {
          ...filterToMap,
          columns: filterToMap.columns.map((column) => {
            const propColumn = props.columns.find((c) => c.dataName == column.dataName);

            const webStorageColumn = _filterWebStorage
              ? _filterWebStorage.columns.find((c) => c.dataName == column.dataName)
              : undefined;

            var hasPrefilter = propColumn?.preFilter || column?.preFilter;

            return {
              ...column,
              ...(hasPrefilter && {
                preFilter: hasPrefilter,
              }),
              format: (propColumn || {}).format,
              inputs: !hasPrefilter && _filterFromService ? (webStorageColumn || propColumn).inputs : column.inputs,
              isFiltered:
                !hasPrefilter && _filterFromService ? (webStorageColumn || propColumn).isFiltered : column.isFiltered,
            };
          }),
        };

    const isExtensible = !!props.columns.find((x) => Object.isExtensible(x));

    if (forceBuilder && isExtensible) {
      props.columns.forEach((x) => (x.inputs = []));
    }

    let config = {
      order: gridConfig.order,
      defaults: {
        order: _.cloneDeep(props.order),
      },
      columns: gridConfig.columns,
      parameters: gridConfig.parameters || [],
      actions: props.actions,
      toolbar: props.toolbar,
      options: props.options,
      pageNumber: props.forceResetPage ? 1 : gridConfig.pageNumber || 1,
      pageSize: gridConfig.pageSize || 10,
      detail: props.detail || undefined,
      masterDetail: props.masterDetail || undefined,
      isView: props.isView,
    };

    return config;
  }

  mapMethodToContext() {
    return {
      setState: this.setStateAndSave.bind(this),
      refreshData: this.refreshData.bind(this),
      setStateAndRefresh: this.setStateAndRefresh.bind(this),
      clearFilters: this.clearFilters.bind(this),
      clearColumn: this.clearColumn.bind(this),
      clearInputs: this.clearInputs.bind(this),
      printGrid: this.printGrid.bind(this),
      getSelectedItens: this.getSelectedItens.bind(this),
      haveItens: this.haveItens.bind(this),
      getFilter: this.getFilter.bind(this),
      getFilterGrid: this.getFilterGrid.bind(this),
      saveConfig: this.saveConfig.bind(this),
      saveConfigOnService: this.saveConfigOnService.bind(this),
      isAnyFilter: this.isAnyFilter.bind(this),
      checkAll: this.checkAll.bind(this),
      onCheckItem: this.onCheckItem.bind(this),
      onCheckAll: this.onCheckAll.bind(this)
    };
  }

  async getFilterFromService(webStorage) {
    var filterConfig = sessionUtils.getItem(webStorage);

    if (filterConfig) return filterConfig;

    const result = await gridService.getConfiguracaoGrid(localUtils.getUser(), sessionUtils.getSistema());
    const { data } = result;
    this.userHasSavedConfig = data && data.ConfiguracaoGrid;
    const configuracao = data && data.ConfiguracaoGrid ? JSON.parse(data.ConfiguracaoGrid) : {};
    return webStorage && configuracao[webStorage] ? JSON.parse(configuracao[webStorage]) : undefined;
  }

  //Getters

  isAnyFilter() {
    return this.state.columns.some((x) => x.isFiltered) || this.state.options.filterByForm;
  }

  isFilterValid() {
    return !this.state.columns.some((x) => !x.isValid);
  }

  getSelectedItens() {
    const { keepSelectedItensOnPages, selectedItens } = this.props;
    let checkedItens = [];

    if (keepSelectedItensOnPages && selectedItens?.length > 0) checkedItens = selectedItens;
    else checkedItens = this.state.data.dataList.filter((x) => x.isChecked);

    return checkedItens;
  }

  getPageItens() {
    return this.state.data.dataList;
  }

  haveItens() {
    return this.state.data.dataList.length > 0;
  }

  getFilter() {
    return {
      order: this.state.order,
      columns: this.state.columns,
      pageNumber: this.state.pageNumber || 1,
      pageSize: this.state.pageSize,
      parameters: this.props.parameters ? this.props.parameters : this.state.parameters,
      recurso: this.state.options.recurso,
    };
  }

  getFilterGrid() {
    const dataFilter = this.getFilter();
    const filter = {
      filterItens: dataFilter.columns,
      filterOrder: dataFilter.order,
      pageNumber: dataFilter.pageNumber,
      pageSize: dataFilter.pageSize,
      parameters: dataFilter.parameters,
      recurso: dataFilter.recurso,
    };
    return filter;
  }

  //Methods
  applyPreFilter(_filterFromService) {
    const { columns } = this.state;

    let newColumns = columns.map((column) => {
      if (column?.preFilter) {
        column.inputs[0].value = column.preFilter;
        column.inputs[1].value = column.preFilter;
        column.isFiltered = true;
      }

      return column;
    });

    this.setState({ columns: newColumns });

    if (_filterFromService) {
      _filterFromService.columns.map((column) => {
        const stateColumn = this.state.columns.find((x) => x.dataName.includes(column.dataName));

        column.preFilter ??= stateColumn?.preFilter;

        if (column?.preFilter || stateColumn?.preFilter) {
          column.inputs[0] = { ...column.inputs[0], value: column?.preFilter ?? stateColumn?.preFilter };
          column.inputs[1] = { ...column.inputs[1], value: column?.preFilter ?? stateColumn?.preFilter };

          column.isFiltered = true;
        }

        return column;
      });
    }
  }

  async refreshData() {
    if (
      this.props.onFetchData &&
      (this.isAnyFilter() || this.props.options.applySearchOnLoad) &&
      (this.isFilterValid() || !this.props.hasFilter)
    ) {
      this.setState({ data: { ...this.state.data, dataList: [] } });

      const data = await this.props.onFetchData(this.getFilter());
      const pageCount = Math.ceil(data.pageCount / this.state.pageSize);
      const querySQL = data.QuerySQL;
      const actualPage = this.state.pageNumber > pageCount ? 1 : this.state.pageNumber;

      await this.setState({ data, isFetched: true, selectedRow: undefined, pageNumber: actualPage, querySQL: querySQL });
      this.props.onLoadData && this.props.onLoadData(data);
      return;
    }

    if (!this.isAnyFilter()) {
      await this.setState({
        data: {
          dataList: [],
          pageCount: 0,
        },
        isFetched: false,
      });
    }
  }

  async refreshDataGrid() {
    this.setState({ data: { ...this.state.data, dataList: [] } });

    const data = await this.props.onFetchData(this.getFilter());
    const pageCount = Math.ceil(data.pageCount / this.state.pageSize);
    const querySQL = data.QuerySQL;
    const actualPage = this.state.pageNumber > pageCount ? 1 : this.state.pageNumber;

    await this.setState({ data, isFetched: true, selectedRow: undefined, pageNumber: actualPage, querySQL: querySQL });
    this.props.onLoadData && this.props.onLoadData(data);
    return;
  }

  clearColumn(column) {
    const { columns } = this.state;
    columns.forEach((x) => {
      if (x.fieldName == column) {
        x.isFiltered = false;
        if (x.inputs) {
          x.inputs = [];
        }
      }
    });
    this.setStateAndSave({
      columns,
      data: { dataList: [], pageCount: 10 },
      isFetched: false,
    });
  }

  clearFilters() {
    const { columns, parameters } = this.state;

    columns.forEach((column) => {
      column.isOpenFilter = false;
      if (column?.preFilter) column.preFilter = undefined;
      if (column.inputs) column.inputs = [];

      if (Array.isArray(column.array))
        column.array.forEach((a) => {
          a.checkItem = false;
        });
    });

    PubSub.publish(commonActionType.CLEAR_INPUTS_GRID);

    if ((parameters.length == 0 && !this.state.toolbar.staticGrid) || this.props.options.clearFilterOnLoad)
      this.setStateAndSave({
        columns,
        data: { dataList: [], pageCount: 0 },
        isFetched: false,
      });
    else this.setStateAndRefresh({ columns });
  }

  setSelectedItem(index, value) {
    const { data } = this.state;
    data.dataList[index].isChecked = value;
    this.onCheckItem(data.dataList[index], value);
    this.setStateAndSave({ data });
  }

  setSelectedItens(action, payload) {
    const { itens, hash } = payload;

    if (hash && hash != this.prop.hash) return;

    const { data } = this.state;
    itens.map((item) => {
      data.dataList[item.index].isChecked = item.value;
    });
    this.onCheckedItensChange(data.dataList.filter((x) => x.isChecked));
    this.setStateAndSave({ data });
  }

  getItem(index) {
    const { data } = this.state;
    return data.dataList[index];
  }

  checkAll(value) {
    const { data } = this.state;

    data.dataList.forEach((x, i) => {
      if (x.merge) data.dataList[i] = x.merge({ isChecked: value });
      else x.isChecked = value;
    });

    this.onCheckAll(value);
    this.setStateAndSave({ data });
  }

  setParameter(key, value, withRefresh = true) {
    const { parameters } = this.state;
    const updateParamValue = (key, value) => {
      let param = parameters.find((x) => x.Nome == key);
      if (!param) parameters.push({ Nome: key, Valor: value });
      else param.Valor = value;
    };
    const isArray = _.isArray(key);
    if (isArray) {
      key.forEach((k) => updateParamValue(k.Nome, k.Valor));
    } else {
      updateParamValue(key, value);
    }
    if ((isArray && value) || withRefresh) this.setStateAndRefresh({ parameters });
    else this.setStateAndSave({ parameters });
  }

  filterOnForm(array, filterByForm) {
    const { parameters } = this.state;
    const updateParamValue = (key, value) => {
      let param = parameters.find((x) => x.Nome == key);
      if (!param) parameters.push({ Nome: key, Valor: value });
      else param.Valor = value;
    };

    array.forEach((k) => updateParamValue(k.Nome, k.Valor));

    const options = {
      ...this.state.options,
      filterByForm,
    };

    this.setStateAndSave(options);
    this.refreshDataGrid();
  }

  //Events
  onCheckItem(item, isCheck, dataList) {
    this.props.onCheckItem && this.props.onCheckItem(item, isCheck, dataList);
    this.onCheckedItensChange(dataList.filter((x) => x.isChecked));
  }

  onCheckedItensChange(itens) {
    this.props.onCheckedItensChange && this.props.onCheckedItensChange(itens);
  }

  onCheckAll(isCheck) {
    const { data } = this.state;

    this.props.onCheckAll && this.props.onCheckAll(isCheck);
    this.onCheckedItensChange(data.dataList.filter((x) => x.isChecked));
  }

  //Internal
  getCurrentConfigToSave(saveFilters = true) {
    const config = {
      options: this.props.options,
      ..._.cloneDeep(this.getFilter()),
    };

    config.columns.forEach((x) => {
      x.isOpenFilter = false;
      if (!saveFilters) {
        x.inputs = [];
      }
    });

    return config;
  }

  async print(type) {
    await this.props.onPrint(this.getFilter(), type);
  }

  warningPrint() {
    _alert.warning('Execute uma busca para fazer a impressão.');
  }

  async printGrid(type) {
    if (!this.state.options.filterByForm) {
      if (
        this.state.isFetched &&
        (this.isAnyFilter() || this.props.options.applySearchOnLoad) &&
        this.isFilterValid()
      ) {
        await this.print(type);
      } else {
        this.warningPrint();
      }
    } else {
      if (this.haveItens()) {
        await this.print(type);
      } else {
        this.warningPrint();
      }
    }
  }

  clearInputs(column) {
    column.inputs = [];
    column.isFiltered = false;
  }

  saveConfig() {
    if (!this.props.options.noStorage && this.props.options.webStorage) {
      sessionUtils.setItem(this.props.options.webStorage, this.getCurrentConfigToSave());
    }
  }

  async saveConfigOnService() {
    const dto = {
      user: localUtils.getUser(),
      idSistema: sessionUtils.getSistema(),
      filter: {
        NomeConfiguracao: this.props.options.webStorage,
        ConfiguracaoGrid: JSON.stringify(this.getCurrentConfigToSave(false)),
      },
    };

    await this.getFilterFromService();

    const saveService = this.userHasSavedConfig
      ? gridService.updateConfiguracaoGrid
      : gridService.createConfiguracaoGrid;

    await saveService(dto);

    _alert.success('Configuração salva com sucesso.');
  }

  async setStateAndRefreshGrid(newState) {
    await this.setStateAndSave(newState);
    await this.refreshDataGrid();
  }

  async setStateAndRefresh(newState) {
    await this.setStateAndSave(newState);
    await this.refreshData();
  }

  async setStateAndSave(action) {
    await this.setState(action);
    this.saveConfig();
  }

  onReloadRequest(action, data) {
    if (!data || data == this.state.hash) this.refreshData();
  }

  clearFilterOnLoad() {
    if (this.props.options.clearFilterOnLoad) this.clearFilters();
  }

  render() {
    return <Provider value={{ ...this.mapMethodToContext(), ...this.state }}>{this.props.children}</Provider>;
  }
}

function withGridContext(WrappedComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props);
    }
    render() {
      return (
        <Consumer>
          {(context) => {
            return <WrappedComponent context={context} {...this.props} />;
          }}
        </Consumer>
      );
    }
  };
}

const ExportTypes = {
  XLS: 0,
  PDFLandscape: 1,
  PDFPortrait: 2,
  TXT: 3,
};

export { withGridContext, ExportTypes };
export default GridFactory;
